export default __webpack_public_path__ + "static/media/mi-filter.281c462b.svg";